export default __webpack_public_path__ + "static/media/flyback_async_int_mosfet_dc_psr_neg.02d798cb.svg";